import React from 'react';

export default function NodeHeader({ data }) {
  return (
    <div className="flex items-center justify-between rounded-lg border bg-slate-50 px-2 py-1.5" style={{ borderColor: data.color }}>
      <strong className="text-sm text-slate-900">{data.title}</strong>
      <span className="rounded-full border border-slate-300 px-2 py-0.5 text-[10px] uppercase text-slate-600">{data.kind}</span>
    </div>
  );
}
